import basePageFields from '@fragments/pages/basePageFields';

export default gql`
    fragment DonationPortalFragment on DonationPortal {
        ${basePageFields}
    }
`;
